import React from "react";

import { Link } from "react-router";

import { Form, Field } from "react-final-form";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { FORM_ERROR } from "final-form";

import { withRouter } from "react-router";

import { TextInput } from "./ui/text-input";
import { FormErrors } from "../components/ui/form-errors";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PublicPage from "./public-page";

import { PasswordToggle } from "../components/ui/password-toggle";

import navigation from "../lib/navigation-utilities";

import _ from "lodash";

import {
  required,
  email,
  maxLength,
  composeField
} from "../lib/form-validators";

const Authenticate = () => {
  const onSubmit = profileContainer => async values => {
    return profileContainer
      .logIn(values.email, values.password)
      .then(wasPreviouslyIdentified =>
        navigation.replace(
          wasPreviouslyIdentified ? "/account/profile" : "/account"
        )
      )
      .catch(() => {
        return { [FORM_ERROR]: "Login failed" };
      });
  };

  return (
    <Subscribe to={[ProfileContainer]}>
      {profileContainer => {
        return (
          <PublicPage>
            <Form
              onSubmit={onSubmit(profileContainer)}
              render={({
                handleSubmit,
                submitting,
                submitError,
                dirtySinceLastSubmit
              }) => (
                <div className="content text-center align-items-center">
                  <form onSubmit={handleSubmit}>
                    <Field
                      name="email"
                      inputClass="dc-login_input"
                      validate={composeField(required, email, maxLength(256))}
                      render={TextInput}
                      placeholder="EMAIL"
                      prependValue={
                        <div className="dc-login_icon">
                          <FontAwesomeIcon
                            icon={["fas", "envelope"]}
                            size="sm"
                            color="#69717a"
                          />
                        </div>
                      }
                    />

                    <hr className="mh-3 w-100" />

                    <Field
                      inputClass="dc-login_input"
                      containerStyle="form-group input-group mb-5"
                      name="password"
                      validate={composeField(required)}
                      render={TextInput}
                      placeholder="PASSWORD"
                      type="password"
                      prependValue={
                        <div className="dc-login_icon">
                          <FontAwesomeIcon
                            icon={["fas", "lock"]}
                            size="sm"
                            color="#69717a"
                          />
                        </div>
                      }
                      appendValue={input => (
                        <div className="dc-login_action">
                          <PasswordToggle inputRef={input} />
                          <Link to="/forgot_password">Forgot?</Link>
                        </div>
                      )}
                    />

                    <FormErrors
                      submitError={submitError}
                      dirtySinceLastSubmit={dirtySinceLastSubmit}
                    />

                    <button
                      type="submit"
                      className="btn btn-primary btn-xl w-100 text-uppercase"
                      disabled={submitting}
                    >
                      Sign In
                    </button>
                  </form>
                </div>
              )}
            />
          </PublicPage>
        );
      }}
    </Subscribe>
  );
};

export default withRouter(Authenticate);
